const cards = [
  {
    title: '社长大人是禽兽',
    tag: '韩漫 · 恋爱',
    desc: '办公室恋情 × 霸道总裁，高人气韩漫持续连载中！细腻画风和紧凑剧情让人欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20businesswoman%20and%20a%20handsome%20CEO%20in%20a%20modern%20office%2C%20soft%20romantic%20lighting%2C%20fashionable%20clothing%2C%20webtoon%20art%20style%2C%20clean%20composition%2C%20warm%20color%20palette&width=600&height=800&seq=card-01-boss&orientation=portrait',
  },
  {
    title: '咒术回战',
    tag: '日漫 · 热血',
    desc: '现象级少年漫，五条悟与虎杖悠仁的超自然战斗故事，销量突破千万！',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20character%20illustration%20with%20intense%20action%20pose%2C%20supernatural%20energy%20effects%2C%20dark%20urban%20background%2C%20anime%20art%20aesthetic%2C%20vibrant%20color%20accents%2C%20shonen%20manga%20cover%20style&width=600&height=800&seq=card-02-jjk&orientation=portrait',
  },
  {
    title: '一人之下',
    tag: '国漫 · 异能',
    desc: '道家文化融合现代都市异能，独特世界观构建令人叹为观止的国漫标杆。',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20character%20illustration%20blending%20Taoist%20elements%20with%20modern%20urban%20fashion%2C%20martial%20arts%20pose%2C%20mystical%20energy%2C%20ink%20brush%20aesthetic%2C%20dramatic%20lighting%2C%20cover%20art%20style&width=600&height=800&seq=card-03-yiren&orientation=portrait',
  },
  {
    title: '我独自升级',
    tag: '韩漫 · 奇幻',
    desc: '全球爆款韩漫！S级猎人觉醒之旅，画风炸裂，每一话都是视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20webtoon%20character%20with%20dark%20armor%20and%20glowing%20eyes%2C%20epic%20fantasy%20style%2C%20dramatic%20lighting%20from%20below%2C%20shadow%20creatures%20in%20background%2C%20professional%20manhwa%20cover%20art%2C%20high%20contrast&width=600&height=800&seq=card-04-solo&orientation=portrait',
  },
  {
    title: '女神降临',
    tag: '韩漫 · 校园',
    desc: '化妆逆袭 × 校园恋爱，超人气韩漫完结篇，COS圈爆款话题之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20stylish%20young%20woman%20with%20flawless%20makeup%2C%20fashionable%20outfit%2C%20soft%20dreamy%20background%20with%20sparkles%2C%20romantic%20atmosphere%2C%20clean%20pretty%20art%20style&width=600&height=800&seq=card-05-goddess&orientation=portrait',
  },
  {
    title: '间谍过家家',
    tag: '日漫 · 喜剧',
    desc: '温馨搞笑间谍家庭喜剧，安妮亚的读心能力带来无限欢乐与感动。',
    image: 'https://readdy.ai/api/search-image?query=A%20charming%20Japanese%20manga%20style%20family%20illustration%20of%20a%20spy%20family%20in%20formal%20attire%2C%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20colorful%20background%2C%20comedy%20anime%20aesthetic%2C%20clean%20composition&width=600&height=800&seq=card-06-spy&orientation=portrait',
  },
  {
    title: '完美世界',
    tag: '国漫 · 仙侠',
    desc: '石昊的逆天修炼之路，宏大世界观与精美画面并存的国漫巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20xianxia%20manhua%20style%20illustration%20of%20a%20young%20warrior%20with%20flowing%20hair%20in%20ancient%20robes%2C%20floating%20mountains%20background%2C%20golden%20energy%20effects%2C%20epic%20fantasy%20atmosphere%2C%20detailed%20ink%20style&width=600&height=800&seq=card-07-perfect&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精选推荐</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精选的高品质漫画，韩漫日漫国漫热门佳作一站推荐
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/70 to-transparent p-3">
                  <span className="text-xs text-background-50 font-medium">{card.tag}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-950">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}

          <div className="col-span-2 lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {cards.slice(4, 7).map((card) => (
              <div
                key={card.title}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
              >
                <div className="relative w-full sm:w-[120px] aspect-[3/4] sm:aspect-[3/4] shrink-0 overflow-hidden bg-background-100">
                  <img
                    src={card.image}
                    alt={card.title}
                    title={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-3 md:p-4 flex flex-col justify-center">
                  <span className="text-xs text-foreground-400 font-medium">{card.tag}</span>
                  <h3 className="font-heading text-sm text-foreground-950 mt-1">{card.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}